export default "__VITE_ASSET__Crz_ZI1b__"